import MoveIcon from "@/assets/icons/move.svg";
import DeleteIcon from "@/assets/icons/trash.svg";
import { Button } from "@/components/ui/button";
import CustomView from "@/domain/entities/customViews/CustomView";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";

type SortableCustomViewProps = {
    view: CustomView;
    handleRemoveViewFromFavorites: (view: CustomView) => void;
};

const SortableCustomView = ({
    view,
    handleRemoveViewFromFavorites,
}: SortableCustomViewProps) => {
    const { t } = useTranslation();
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: view.id! });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    if (!view.id) {
        return null;
    }

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="flex w-full items-center justify-between gap-2 bg-surface-primary px-4 py-2"
        >
            <div className="flex items-center gap-2">
                <img alt="Move" className="h-4 w-4" src={MoveIcon} />
                {view.name}
            </div>
            <Button
                className="p-0"
                onClick={() => {
                    handleRemoveViewFromFavorites(view);
                }}
                size="smIcon"
                variant="ghost"
            >
                <img
                    alt={t("settings.homepage.customViews.delete")}
                    className="h-4 w-4"
                    src={DeleteIcon}
                />
            </Button>
        </div>
    );
};

export default SortableCustomView;
